import { Card } from "react-bootstrap"
import { translation } from "../../../helper/translation"

export const ContentAboutMePageCompanyLogos = () => {

    const companyLogos = [
        ["Best Systems GmbH", "best_systems_logo.png"],
        ["Greenbird Vertriebs GmbH", "greenbird_logo.svg"],
        ["CompuGroup Medical", "cgm_logo.webp"],
        ["SoftCard Softwareentwicklungs GmbH","softcard_logo.png"],
        ["kraftwerk | Agentur für neue Kommunikation", "kraftwerk_logo.svg"],
        ["Alge EDV Consulting GmbH", "logo_alge.png"],
        ["medani gmbh", "medani_digital_logo.jpeg"],
        ["Volkswagen", "wv_logo.png"],
        ["Audi", "audi_logo.png"],
        ["BMW", "bmw_logo.png"],
    ]

    
    return(
        <div className="contest-details">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="main-content">
                            <h4>{translation("partners-clients-title")}</h4>
                            {/* <h6>{translation("about-me-heading")}</h6> */}
                            <span>{translation("company-logos-intro")}</span>

                            <div className="row mt-5">
                                <div className="col-lg-12" style={{background: '#e7f9ff'}}>
                                    {
                                        companyLogos.map((el, index) => {
                                            return(
                                                <div className="col max-w-200 float-start height-150" key={index}>
                                                    <img src={`/assets/images/companies/${el[1]}`} alt={el[0]} />
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}